/**
 * @Author: forguo
 * @Date: 2024/1/6 11:12
 * @Description: i18n
 */
import Vue from 'vue'
import I18n from 'vue-i18n'
// import { getUrlParams } from '../common/utils'
import Languages from './langs'
Vue.use(I18n)

// 默认语言
// let url = window.location.href
let locale = 'en'
// if (url.indexOf('login') > -1) {
//   let browswerLanguage = navigator.language || navigator.browserLanguage
//   if (browswerLanguage == 'zh-CN') {
//     locale = 'zh-cn'
//   } else if (browswerLanguage == 'zh-TW') {
//     locale = 'zh-tw'
//   } else if (browswerLanguage == 'en') {
//     locale = 'en'
//   } else if (browswerLanguage == 'id' || browswerLanguage == 'id-ID') {
//     locale = 'id'
//   } else {
//     locale = 'en'
//   }
//   // zh-TW zh-CN en id
// } else {
//   locale = getUrlParams(window.location.href, 'language') || localStorage.getItem('language') || 'en'
//   let LanguagesKeys = Object.keys(Languages)
//   if (!LanguagesKeys.includes(locale)) {
//     locale = 'en'
//   }
// }

const i18n = new I18n({
  // 默认语言
  locale,
  fallbackLocale: 'zh-cn',
  // 语言包
  messages: Languages
})

export default i18n
